import React, { useState, useEffect } from 'react';

// Renders a partner avatar with graceful fallback to initials.
// Falls back when (a) no url is supplied, or (b) the <img> emits onError —
// e.g. a stale CoachProfile.avatar_url that 401s because it was stored
// before the authorized-URL fix landed, or a Document that was deleted.
// Resets the errored flag if the url changes (so a re-upload re-attempts).
export default function PartnerAvatar({
  url,
  name,
  initials,
  sizeClass = 'w-12 h-12',
  textSizeClass = 'text-[16px]',
  className = '',
}) {
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [url]);

  if (url && !errored) {
    return (
      <img
        src={url}
        alt={name || ''}
        onError={() => setErrored(true)}
        className={`${sizeClass} rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-muted flex items-center justify-center text-foreground font-semibold ${textSizeClass} ${className}`}
    >
      {initials}
    </div>
  );
}
